export function run(next) {
  return next();
}